// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as actions from '../store/actions'
import CartSummary from '../components/cart-summary'
import get from 'lodash/get'

const mapStateToProps = ({ cart }) => {
  const props = {
    shippingRateType: get(cart.getProductInfoFromServerResponse, 'shipping_cost.shipping_rate_type', 1),
    shippingFirstItem: get(cart.getProductInfoFromServerResponse, 'shipping_cost.first_item', 0),
    shippingAdditionalItem: get(cart.getProductInfoFromServerResponse, 'shipping_cost.additional_item', 0),
    minimalAmountForFreeShipping: get(
      cart.getProductInfoFromServerResponse,
      'shipping_cost.minimal_amount_for_free_shipping',
      undefined
    ),
    pricesInclTax: get(cart.getProductInfoFromServerResponse, 'tax_cost.prices_incl_tax', false),
    fromEu: get(cart.getProductInfoFromServerResponse, 'tax_cost.from_eu', false),
    calculateTaxOverShipping: get(cart.getProductInfoFromServerResponse, 'tax_cost.calculate_tax_over_shipping', false),
    automaticTaxes: get(cart.getProductInfoFromServerResponse, 'tax_cost.automatic_taxes', false),
    currentTaxPercent: get(cart.getProductInfoFromServerResponse, 'tax_cost.tax_percent_region', 0),
    taxOriginal: get(cart.getProductInfoFromServerResponse, 'tax_cost.tax_original', 0)
  }

  return {
    checkoutUrlRetrieving: cart.createCheckOutSessionRetrieving || cart.checkDiscountCodeRetrieving,
    checkoutUrl: get(cart.createCheckOutSessionResponse, 'url'),
    getProductInfoFromServerResponse: cart.getProductInfoFromServerResponse,
    persistentDiscounts: cart.discounts,
    ...props
  }
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatch
)(CartSummary)
